//@ flow
const formatBaseline = (payload) => {
    const {
        value,
        decimals,
        rowIndex,
        lineItemUrid,
        ucid
    } = payload;
    window.dispatchEvent(
        new CustomEvent('formatBaseline', {
            detail: {
                payload: 'Baseline cell formatted successfully',
                stopLoading: true,
                type: 'success',
                value: value,
                decimals: decimals,
                rowIndex: rowIndex,
                lineItemUrid: lineItemUrid,
                ucid: ucid
            }
        })
    );
    return;
}

export default formatBaseline;
